import React, { useContext } from 'react';

import { NowPlayingContext } from '../../../contexts/now-playing.context';
import { PlayerContext } from '../../../contexts/player.context';

import { PlaybackWrapper, PlaybackButton } from './PlaybackControls.styles';

import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from 'react-icons/md';
import { TiMediaPause, TiMediaPlay } from 'react-icons/ti';

const PlaybackControls = ({ handleJump }) => {
  const { setPlaying, isPlaying } = useContext(NowPlayingContext);
  const { minimized } = useContext(PlayerContext);

  return (
    <PlaybackWrapper>
      {!minimized && (
        <PlaybackButton onClick={() => handleJump(-10)}>
          <MdKeyboardArrowLeft />
        </PlaybackButton>
      )}

      <PlaybackButton
        style={{ margin: minimized ? '0 0 0 2rem' : '0 2rem' }}
        fontSize="32"
        onClick={() => setPlaying(!isPlaying)}
        minimized={minimized}
      >
        {isPlaying ? <TiMediaPause /> : <TiMediaPlay />}
      </PlaybackButton>
      {!minimized && (
        <PlaybackButton onClick={() => handleJump(30)}>
          <MdKeyboardArrowRight />
        </PlaybackButton>
      )}
    </PlaybackWrapper>
  );
};

export default PlaybackControls;
